import {environment} from '@env/environment';
import {Injectable} from '@angular/core';
import {AbstractBackendService} from '@shared/interfaces/service-classes';
import {TipoEmisorModel} from '@shared/models/tipo-emisor.model';

@Injectable()
export class TiposEmisorUserService extends AbstractBackendService<TipoEmisorModel, undefined> {

  buildUrlBase(): string {
    return `${environment.api.cuenta.tiposEmisor.user}`;
  }

}
